<!--TOOLBAR MENU-->
<div id="toolbarMenu">
	@if (user?.isHost && !settings.license.serialNumber) {
		<span class="toolbarError">{{ T.PROVIDE_SERIAL_NUMBER_ERROR_MSG | translate }}</span>
	}

	@if (!!currentClientWifi) {
		<div style="display: flex; align-items: center">
			<mat-icon
				fontSet="fad"
				fontIcon="{{ getClientWifiIcon(currentClientWifi) }}"
				inline
				matTooltipClass="accent"
				[matTooltip]="T.SHARED_MENU_WIFI_SIGNAL_STRENGTH | translate: {strength: Math.round(currentClientWifi?.strength)}"
			/>
		</div>
	}

	<sim-battery-state class="batteryIcon" />

	<span class="timeWidget">
		<mat-icon fontIcon="fa-clock" fontSet="fas" inline />
		<label [attr.data-testid]="'menu-time'">
			{{ localTime | date: (T.DATE_FORMAT_TIME | translate) : "" : translate.currentLang }}
		</label>
	</span>

	@if (clientAudioDeviceComponent.isClientDeviceUsed) {
		<button
			(click)="containerIconClicked(ShowContainer.AudioDevice)"
			[class.isOpen]="showContainer === ShowContainer.AudioDevice"
			class="notificationsButton"
			mat-icon-button
			matTooltip="{{ T.SHARED_MENU_AUDIO_DEVICES | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon
				[fontIcon]="
					clientAudioDeviceComponent.audioClient?.connected?.() && !clientAudioDeviceComponent.audioClient?.muted?.()
						? 'fa-microphone'
						: 'fa-microphone-slash'
				"
				fontSet="fa"
				inline
			/>
		</button>
	}

	@if (isWifiManagementEnabled) {
		<button
			(click)="containerIconClicked(ShowContainer.Wifi)"
			[class.isOpen]="showContainer === ShowContainer.Wifi"
			[matTooltip]="T.SHARED_MENU_WIFI_SIGNAL_STRENGTH | translate: {strength: Math.round(currentServerWifi?.signalStrength)}"
			[matTooltipDisabled]="!currentServerWifi"
			hasPermission="WifiManagement_Access"
			mat-icon-button
			matTooltipClass="accent"
		>
			<mat-icon fontSet="fa" fontIcon="fa-router" inline />
			@if (!!currentServerWifi) {
				<mat-icon fontSet="fa" class="networkCheck" fontIcon="fa-check" />
			}
		</button>
	}

	@if (settings.enableDebugMode) {
		<button
			(click)="toggleTranslationKeys()"
			mat-icon-button
			matTooltip="{{ T.SHARED_MENU_TOGGLE_TRANSLATION_KEY | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon fontIcon="fa-key-skeleton" fontSet="fa" inline />
		</button>
	}

	@if (settings.enableDebugMode) {
		<button
			(click)="togglePermissionTooltips()"
			mat-icon-button
			matTooltip="{{ T.SHARED_MENU_TOGGLE_PERMISSIONS_CHECK | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon [fontSet]="showPermissionTooltips ? 'fal' : 'fa'" fontIcon="fa-id-badge" inline />
		</button>
	}

	@if (settings.visibleLanguages?.length > 1) {
		<button
			[matMenuTriggerFor]="languageMenu"
			[matTooltip]="T.GENERAL_TXT_SELECT_LANGUAGE | translate"
			mat-icon-button
			matTooltipClass="accent"
		>
			<mat-icon fontIcon="fa-language" fontSet="fas" inline style="font-size: 1.2em" />
		</button>
		<mat-menu #languageMenu="matMenu">
			@for (lang of settings.visibleLanguages ?? []; track lang) {
				<button
					(click)="changeLanguage(lang)"
					[style.background-color]="setActiveLang === lang ? 'rgba(0 0 0 / 0.2)' : ''"
					mat-menu-item
				>
					{{ langDict[lang] ?? lang }}
				</button>
			}
		</mat-menu>
	}

	@if (!!SettingButtonShow && !isScope(Scope.OfflineDebriefing)) {
		<button
			(click)="openSettingsDialog()"
			aria-label="Settings"
			hasPermission="UserManagement_EditAll"
			mat-icon-button
			matTooltip="{{ T.SHARED_MENU_OPEN_SETTINGS_DIALOG | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon fontIcon="fa-cog" fontSet="fas" inline style="font-size: 0.9em" />
		</button>
	}
	<button
		(click)="openVersionInfoDialog()"
		aria-label="Sidebar Navigation Menu Button"
		mat-icon-button
		matTooltip="{{ T.SHARED_MENU_SHOW_INFO_DIALOG | translate }}"
		matTooltipClass="accent"
	>
		<mat-icon fontIcon="fa-question-circle" fontSet="fas" inline style="font-size: 0.9em" />
	</button>

	@if (hasLicenseModule(Modules.Export)) {
		<button
			(click)="containerIconClicked(ShowContainer.Export)"
			[class.currentlyExporting]="runningExport"
			[class.isOpen]="showContainer === ShowContainer.Export"
			[matBadgeHidden]="exportsInProgress <= 0"
			[matBadge]="exportsInProgress"
			aria-label="Sidebar Navigation Menu Button"
			class="notificationsButton"
			mat-icon-button
			matBadgeColor="warn"
			matTooltip="{{ T.RECORDINGS_EXPORT_TEXT | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon fontIcon="fa-arrow-alt-to-bottom" fontSet="fas" inline style="font-size: 0.9em" />
		</button>
	}

	@if (!isScope(Scope.OfflineDebriefing)) {
		<button
			(click)="containerIconClicked(ShowContainer.Notification)"
			[@bounce]="animateNotification"
			[class.isOpen]="showContainer === ShowContainer.Notification"
			[matBadgeHidden]="notifications.length <= 0"
			[matBadge]="notifications.length"
			aria-label="Sidebar Navigation Menu Button"
			class="notificationsButton"
			mat-icon-button
			matBadgeColor="warn"
			matTooltip="{{ T.SHARED_MENU_OPEN_NOTIFICATIONS_OVERLAY | translate }}"
			matTooltipClass="accent"
		>
			<mat-icon fontIcon="fa-bell" fontSet="fas" inline style="font-size: 0.8em" />
		</button>
	}

	<button
		(click)="openPowerOffDialog()"
		[matTooltip]="T.GENERAL_TXT_LOG_OUT_OF_SIMSTATION | translate"
		aria-label="Sidebar Navigation Menu Button"
		mat-icon-button
		matTooltipClass="accent"
	>
		<mat-icon fontIcon="fa-sign-out" fontSet="fas" inline style="font-size: 0.9em" />
	</button>
</div>

<!--NOTIFICATIONS-->
@if (showContainer === ShowContainer.Notification) {
	<div [@fadeInExpandOnEnter] [@fadeOutCollapseOnLeave] class="mat-elevation-z8 notificationContainer">
		<span class="triangle"></span>
		<div class="notificationContentContainer">
			<div class="notificationHeader">
				<i class="fad fa-bell headerIcon"></i>
				<div class="text mat-h2 nomargin">
					{{ T.SHARED_MENU_NOTIFICATIONS | translate }}
				</div>
				<button (click)="containerIconClicked(ShowContainer.None)" class="closeNotificationButton" color="warn" mat-icon-button>
					<mat-icon fontIcon="fa-times" fontSet="fas" inline style="font-size: 0.9em" />
				</button>
			</div>
			<mat-divider class="notificationContainerDivider" />
			<div [@listStagger]="notifications?.length" class="notificationEntries">
				@for (notification of notifications; track notification) {
					<div class="notificationEntry {{ NotificationType[notification.type] }}">
						<div class="upper">
							<div class="notificationIcon">
								@switch (notification.type) {
									@case (NotificationType.ERROR) {
										<i class="fad fa-exclamation-circle"></i>
									}
									@case (NotificationType.WARNING) {
										<i class="fad fa-exclamation-triangle"></i>
									}
									@default {
										<i class="fad fa-bell"></i>
									}
								}
							</div>
							<div class="notificationEntryContent">
								<div class="notificationEntryBody notificationDateTimeStyle">
									{{ notification?.notificationTime | date: (T.DATE_FORMAT_LONG | translate) }}
									{{ notification.notificationTime ? "|" : "" }}
									{{ notification?.notificationTime | date: (T.DATE_FORMAT_TIME | translate) }}
								</div>
								<div class="notificationEntryHeader">
									<div class="notificationEntryHeaderTitle">
										{{ notification.title | translate }}
									</div>
								</div>
								<div class="notificationEntryBody">
									@if (Array.isArray(notification.message)) {
										<ul>
											@for (message of notification.message; track message) {
												<li>{{ message | translate }}</li>
											}
										</ul>
									} @else {
										{{ notification.message | translate }}
									}
								</div>
							</div>
						</div>
						<mat-divider class="notificationActionsDivider" />
						<div class="notificationActions">
							@if (notification.category === NotificationCategory.HEALTH_ERROR) {
								<button
									(click)="containerIconClicked(ShowContainer.None)"
									color="accent"
									mat-button
									routerLink="/health-monitor"
								>
									{{ T.SHARED_MENU_OPEN_MONITOR | translate }}
								</button>
							}
							@if (notification.category === NotificationCategory.UPDATE_AVAILABLE) {
								<button (click)="updateSimStationNotificationClicked()" color="accent" mat-button>
									{{ T.UPDATE_SIMSTATION_INFO | translate }}
								</button>
							}
						</div>
					</div>
				}
				@if (!notifications || notifications.length === 0) {
					<div class="noNotificationsContainer">
						<i class="fad fa-bell-slash noNotificationsIcon"></i>
						<div class="mat-h2 nomargin">
							{{ T.SHARED_MENU_NO_NOTIFICATIONS | translate }}
						</div>
					</div>
				}
			</div>
		</div>
	</div>
}

@if (showContainer === ShowContainer.Export) {
	<div [@fadeInExpandOnEnter] [@fadeOutCollapseOnLeave] class="mat-elevation-z8 notificationContainer exportsContainer">
		<span class="triangle"> </span>
		<div class="notificationContentContainer">
			<div class="notificationHeader">
				<i class="fad fa-download headerIcon"></i>
				<div class="text mat-h2 nomargin">
					{{ T.SHARED_MENU_EXPORTS | translate }}
				</div>
				<div class="exportConActions">
					<button
						(click)="loadCurrentExports(true)"
						[matTooltipClass]="'accent'"
						[matTooltip]="T.EXPORT_NOTIFICATION_CON_REFRESH | translate"
						color="accent"
						mat-icon-button
					>
						<mat-icon fontIcon="fa-sync" fontSet="fad" inline />
					</button>
					<button
						(click)="containerIconClicked(ShowContainer.None)"
						[matTooltipClass]="'warn'"
						[matTooltip]="T.SETTING_MODAL_CLOSE | translate"
						class="closeNotificationButton"
						color="warn"
						mat-icon-button
					>
						<mat-icon fontIcon="fa-times" fontSet="fas" inline style="font-size: 0.9em" />
					</button>
				</div>
			</div>
			<mat-divider class="notificationContainerDivider" />
			<div
				[@listStagger]="allExports?.length"
				[class.justify-content-center]="!loadingExports && (!allExports || allExports.length === 0 || !hasOnlyDismissedExports())"
				class="notificationEntries"
			>
				@for (exportInfo of allExports; track TrackByMethods.trackById($index, exportInfo)) {
					@if (exportInfo.visualState !== ExportVisualState.Dismissed && !loadingExports) {
						<div class="notificationEntry">
							<div class="upper">
								<div class="notificationIcon">
									@switch (exportInfo.exportState) {
										@case (ExportState.Idle) {
											<i class="fad fa-hourglass-start"></i>
										}
										@case (ExportState.Exporting) {
											<i class="fad fa-spinner-third fa-spin"></i>
										}
										@case (ExportState.Pausing) {
											<i class="fad fa-stop-circle"></i>
										}
										@case (ExportState.Paused) {
											<i class="fad fa-stop-circle"></i>
										}
										@case (ExportState.Canceling) {
											<i class="fad warn2 fa-exclamation-circle"></i>
										}
										@case (ExportState.Canceled) {
											<i class="fad warn2 fa-exclamation-circle"></i>
										}
										@case (ExportState.Finished) {
											<i class="fad accent fa-check"></i>
										}
										@case (ExportState.Failed) {
											<i class="fad warn fa-times"></i>
										}
										@default {
											<i class="fad fa-download"></i>
										}
									}
								</div>
								<div class="notificationEntryContent">
									<div class="notificationEntryHeader">
										<div class="exportDate">
											{{
												exportInfo.exportedDate
													| date: (T.DATE_FORMAT_LONG_DAY | translate) : "" : translate.currentLang
											}}
										</div>
									</div>
									@let scenarioRecording = exportInfo.scenarioRecordingId | getScenarioRecordingById | async;
									<div class="notificationEntryBody">
										<div class="scenarioRecordingLine">
											<div class="descriptiveText">
												{{ T.EXPORT_CON_EVENT_TXT | translate }}
											</div>
											<div class="value">
												{{
													scenarioRecording
														? (scenarioRecording.id | getEventByScenarioRecordingId | async)?.name
														: "..."
												}}
											</div>
										</div>
										<div class="scenarioRecordingLine">
											<div class="descriptiveText">
												{{ T.EXPORT_CON_SESSION_TXT | translate }}
											</div>
											<div class="value">
												{{
													scenarioRecording
														? (scenarioRecording.trainingSessionId | getTrainingSessionbyId | async)?.title
														: "..."
												}}
											</div>
										</div>
										<div class="scenarioRecordingLine">
											<div class="descriptiveText">
												{{ T.EXPORT_CON_SCENARIO_TXT | translate }}
											</div>
											<div class="value">
												{{ scenarioRecording ? scenarioRecording.scenario?.name : "..." }}
											</div>
										</div>
										<div class="scenarioRecordingLine">
											<div class="descriptiveText">
												{{ T.EXPORT_CON_NAME_TXT | translate }}
											</div>
											<div class="value">
												{{ scenarioRecording ? scenarioRecording?.name : "..." }}
											</div>
										</div>
									</div>
								</div>
							</div>
							<mat-divider class="notificationActionsDivider" />
							<div class="notificationActions">
								<div class="exportStatus">
									@if (exportInfo.exportState === ExportState.Exporting) {
										<mat-progress-bar
											[mode]="'determinate'"
											[value]="exportInfo.progress * 100 | round: 2"
											color="accent"
										/>
									}
									@if (exportInfo.exportState === ExportState.Exporting) {
										<div class="statusTextForProgress">
											{{ T.RECORDINGS_EXPORT_PANEL_STATUS_EXPORTING | translate }}
											{{ exportInfo.progress * 100 | round: 2 }}
											%
										</div>
									}
									@if (exportInfo.exportState === ExportState.Finished) {
										<div class="statusTextForExport">
											{{ T.EXPORT_FINISHED_STATUS_TXT | translate }}
										</div>
									}
									@if (exportInfo.exportState === ExportState.Pausing || exportInfo.exportState === ExportState.Paused) {
										<div class="statusTextForExport">
											{{ T.EXPORT_PAUSED_STATUS_TXT | translate }}
										</div>
									}
									@if (
										exportInfo.exportState === ExportState.Canceling || exportInfo.exportState === ExportState.Canceled
									) {
										<div class="statusTextForExport">
											{{ T.EXPORT_CANCELED_STATUS_TXT | translate }}
										</div>
									}
									@if (exportInfo.exportState === ExportState.Idle) {
										<div class="statusTextForExport">
											{{ T.EXPORT_SCHEDULED_STATUS_TXT | translate }}
										</div>
									}
								</div>
								@if (exportInfo.exportState === ExportState.Finished || exportInfo.exportState === ExportState.Idle) {
									<button
										(click)="deleteExport(exportInfo)"
										[matTooltip]="T.EXPORT_CON_REMOVE_EXPORT_TOOLTIP | translate"
										class="exportActionBtn"
										color="warn"
										mat-icon-button
										matTooltipClass="warn"
									>
										<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline />
									</button>
								}
								@if (exportInfo.exportState === ExportState.Paused || exportInfo.exportState === ExportState.Exporting) {
									<button
										(click)="cancelExport(exportInfo.id)"
										[matTooltip]="T.EXPORT_CON_REMOVE_EXPORT_TOOLTIP | translate"
										class="exportActionBtn"
										color="warn"
										mat-icon-button
										matTooltipClass="warn"
									>
										<mat-icon fontIcon="fa-stop-circle" fontSet="fad" inline />
									</button>
								}
								@if (exportInfo.exportState === ExportState.Finished) {
									<button
										(click)="downloadExport(exportInfo.id)"
										[matTooltip]="T.EXPORT_CON_DOWNLOAD_EXPORT_TOOLTIP | translate"
										class="exportActionBtn"
										color="accent"
										mat-icon-button
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-download" fontSet="fad" inline />
									</button>
								}
								@if (exportInfo.exportState === ExportState.Exporting) {
									<button
										(click)="pauseExport(exportInfo.id)"
										class="exportActionBtn"
										color="accent"
										mat-icon-button
										matTooltip="Pause Export"
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-pause" fontSet="fad" inline />
									</button>
								}
								@if (exportInfo.exportState === ExportState.Paused) {
									<button
										(click)="resumeExport(exportInfo.id)"
										class="exportActionBtn"
										color="accent"
										mat-icon-button
										matTooltip="Start Export"
										matTooltipClass="accent"
									>
										<mat-icon fontIcon="fa-play" fontSet="fad" inline />
									</button>
								}
								@if (exportInfo.exportState === ExportState.Failed || exportInfo.exportState === ExportState.Canceled) {
									<button (click)="dismissExport(exportInfo.id)" color="accent" mat-button>
										{{ T.BUTTON_DISMISS | translate }}
									</button>
								}
							</div>
						</div>
					}
				}
				<div class="loadingExportsCon">
					<sim-component-loading-container [isLoading]="loadingExports" loadingIcon="fad fa-download" />
				</div>
				@if (!loadingExports && (!allExports || allExports.length === 0 || !hasOnlyDismissedExports())) {
					<div class="noNotificationsContainer">
						<i class="fad fa-download noNotificationsIcon"></i>
						<div class="mat-h2 nomargin">
							{{ T.SHARED_MENU_NO_EXPORTS | translate }}
						</div>
					</div>
				}
			</div>
			<button
				[hasPermission]="Permissions.Scheduler_Export"
				(click)="containerIconClicked(ShowContainer.None)"
				class="seeAllExportsBtn"
				color="accent"
				mat-button
				routerLink="/web-manager/list/sim-schedulers-jobs/export-jobs"
			>
				{{ T.RECORDINGS_EXPORT_DIALOG_SEE_ALL_TASKS | translate }}
			</button>
		</div>
	</div>
}

<sim-client-audio-device
	[hidden]="showContainer !== ShowContainer.AudioDevice"
	(closeComponent)="containerIconClicked(ShowContainer.None)"
	[@fadeInExpandOnEnter]
	[@fadeOutCollapseOnLeave]
	#clientAudioDeviceComponent
	class="mat-elevation-z8 notificationContainer"
/>

@if (showContainer === ShowContainer.Wifi) {
	<div [@fadeInExpandOnEnter] [@fadeOutCollapseOnLeave] class="mat-elevation-z8 notificationContainer wifiContainer">
		<div class="notificationContentContainer">
			<div class="notificationHeader">
				<i class="fad fa-router headerIcon"></i>
				<div class="text mat-h2 nomargin">
					{{ T.SHARED_MENU_WIFI_NETWORKS | translate }}
				</div>
				<button (click)="containerIconClicked(ShowContainer.None)" class="closeNotificationButton" color="warn" mat-icon-button>
					<mat-icon fontIcon="fa-times" fontSet="fas" inline style="font-size: 0.9em" />
				</button>
			</div>
			<mat-divider class="notificationContainerDivider" />
			<div class="notificationEntries">
				@for (network of serverWifiNetworks; track network) {
					<div (click)="connectToWifiNetwork(network)" class="networkListItem">
						<mat-icon
							fontSet="fad"
							fontIcon="{{ getServerWifiIcon(network) }}"
							[matTooltip]="
								T.SHARED_MENU_WIFI_SIGNAL_STRENGTH
									| translate
										: {
												strength: Math.round(network?.signalStrength),
										  }
							"
							matTooltipClass="accent"
							color="{{ network.isConnected ? 'accent' : undefined }}"
						/>
						@if (network.isSecure) {
							<mat-icon
								[matTooltip]="T.SHARED_MENU_SECURE_WIFI_NETWORK | translate"
								fontIcon="fa-lock"
								fontSet="fad"
								matTooltipClass="accent"
							/>
						}
						<div class="name">
							{{ network.name }}
						</div>
						<div class="wifiActions">
							@if (network.isConnected) {
								<button
									(click)="disconnect()"
									[matTooltip]="T.SHARED_MENU_DISCONNECT_WIFI_NETWORK | translate"
									appStopPropagation
									color="warn"
									mat-icon-button
									matTooltipClass="warn"
								>
									<mat-icon fontIcon="fa-wifi-slash" fontSet="fad" inline />
								</button>
							}
							@if (network.hasProfile) {
								<button
									(click)="forget(network)"
									[matTooltip]="T.SHARED_MENU_FORGET_WIFI_NETWORK | translate"
									appStopPropagation
									color="warn"
									mat-icon-button
									matTooltipClass="warn"
								>
									<mat-icon fontIcon="fa-trash-alt" fontSet="fad" inline />
								</button>
							}
						</div>
					</div>
				}
				@if (!serverWifiNetworks) {
					<div>
						{{ T.SHARED_MENU_NO_WIFI_NETWORKS | translate }}
					</div>
				}
			</div>
		</div>
	</div>
}
